import React from 'react';
import { getRemainingPoints } from '../utils/pathCalculations';
import '../../../styles/modes/customMode.css';

const AvailablePoints = ({ customPath, availablePoints, selectNextPoint, pathComplete }) => {
  // Only show if path is not complete and there are points in the path
  if (pathComplete || customPath.length === 0) {
    return null;
  }
  
  const remainingPoints = getRemainingPoints(availablePoints, customPath);
  
  return (
    <div className="available-points">
      <h5>Select Next Location Point</h5>
      <div className="available-points-list">
        {remainingPoints.map(point => (
          <button
            key={`available-${point.id}-${Math.random().toString(36).substr(2, 9)}`}
            className="available-point-btn"
            onClick={() => selectNextPoint(point)}
          >
            {point.name}. {point.latitude.toFixed(4)}, {point.longitude.toFixed(4)}
          </button>
        ))}
      </div>
    </div>
  );
};

export default AvailablePoints; 